import React from 'react';

import styled from 'styled-components';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

const MenuLi = styled.li`
    display: inline-block;
`;

const UserInfoLi = styled(MenuLi)`
    margin-right: 16px;
`;

const BookmarkMenuItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 140px;
`;

const BookmarkActionLabel = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
`;

const BOOKMARK_BASE_URL = 'https://crm.homestation.jp';

class NavMenu extends React.Component {
    constructor(props) {
        super(props);

        this.addBookmark = this.addBookmark.bind(this);
        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false,
            dropdownOpenStar: false,
            dropdownOpenCog: false,
            dropdownOpenBookmark: false
        };
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    getBookmarkLabel(pathname) {
        const bookmarkLabels = {
            '/': '反響一覧',
            '/ResponseList': '反響一覧',
            '/ResponseListCS': '反響一覧CS',
            '/responselistcs': '反響一覧CS',
            '/DashBoard': 'ダッシュボード',
            '/dashboard': 'ダッシュボード',
            '/contractfollow': '契約フォロー',
            '/Calendar': 'カレンダー',
            '/calendar': 'カレンダー',
            '/CalendarAll': '全店カレンダー',
            '/Schedule': 'スケジュール',
            '/Mail': 'メール',
            '/MailTemplate': 'テンプレ',
            '/Corporation': '法人',
            '/corporation': '法人',
            '/YoyakuParking': '駐車場予約',
            '/StockRooms': 'ストック',
            '/ResponseAnalytics': '反響分析',
            '/ResponseFollowSheet': '反響追客シート',
            '/OtherSales': 'その他売上',
            '/Approval': '承認',
            '/Entrusted': '管理受託',
            '/EntrustedList': '管理受託一覧',
            '/ContractManagementComponent': '契約管理',
            '/CustomerContacts': '顧客連絡',
            '/Search': '検索',
            '/Map': '地図',
            '/Rent': '賃貸'
        };

        return bookmarkLabels[pathname] || pathname;
    }

    normalizeBookmarkUri(uri) {
        return (uri || '').replace(BOOKMARK_BASE_URL, '');
    }

    getCurrentBookmark() {
        const pathname = this.props.pathname;
        return this.props.bookmarks.find(bookmark => this.normalizeBookmarkUri(bookmark.uri) === pathname);
    }

    hasCurrentBookmark() {
        return !!this.getCurrentBookmark();
    }

    addBookmark() {
        const pathname = this.props.pathname;
        const label = this.getBookmarkLabel(pathname);
        const currentBookmark = this.getCurrentBookmark();

        if (currentBookmark) {
            this.props.delete_bookmark(currentBookmark.id);
            return;
        }

        this.props.insert_bookmark({ name: label, uri: BOOKMARK_BASE_URL + pathname });
    }


    render() {

        const result = this.props.shops.filter(x => x.tenpoNo === this.props.user_details.amSectionId);
        const hasCurrentBookmark = this.hasCurrentBookmark();


        //    alert(shops.tenpoName)
        return (
            <header>

                <div style={{ textAlign: "right", height: "100%" }}>

                    <a href="https://www.homestation.jp/manage/top/index">
                        <i className="icon-homestation navbar-brand" style={{ lineHeight: "inherit" }}></i>
                    </a>
                    {/* <nav> */}




                    <ul className="">


                        <UserInfoLi>
                            ログイン中： {!result[0] ? "" : result[0].tenpoName}　{this.props.user_details.userNameAll}
                        </UserInfoLi>
                      
                        <MenuLi className="dropdown" >
                            <Dropdown direction="down" isOpen={this.state.dropdownOpenStar} toggle={() => { this.setState({ dropdownOpenStar: !this.state.dropdownOpenStar }); }}>
                                <DropdownToggle
                                    tag="span"
                                    className="fas fa-star navbar-menu"
                                    style={{ color: hasCurrentBookmark ? '#f4c542' : undefined }}
                                    data-toggle="dropdown"
                                    aria-expanded={this.state.dropdownOpenStar}
                                >
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem onClick={this.addBookmark}>
                                        <BookmarkActionLabel>
                                            <i className={`fas ${hasCurrentBookmark ? 'fa-star-half-alt' : 'fa-star'}`}></i>
                                            <span>{hasCurrentBookmark ? 'ブックマーク削除' : 'ブックマーク追加'}</span>
                                        </BookmarkActionLabel>
                                    </DropdownItem>
                                    <DropdownItem divider />
                                    <Dropdown
                                        direction="left"
                                        isOpen={this.state.dropdownOpenBookmark}
                                        toggle={() => {}}
                                        onMouseEnter={() => { this.setState({ dropdownOpenBookmark: true }); }}
                                        onMouseLeave={() => { this.setState({ dropdownOpenBookmark: false }); }}
                                    >
                                        <DropdownToggle
                                            tag="div"
                                            className="dropdown-item"
                                            data-toggle="dropdown"
                                            aria-expanded={this.state.dropdownOpenBookmark}
                                        >
                                            <BookmarkMenuItem>
                                                <span>ブックマーク</span>
                                                <span className="fas fa-caret-right"></span>
                                            </BookmarkMenuItem>
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {this.props.bookmarks.length > 0 ?
                                                this.props.bookmarks.map(bookmark => (
                                                    <DropdownItem key={bookmark.id || bookmark.uri} href={bookmark.uri}>{bookmark.name}</DropdownItem>
                                                ))
                                                :
                                                <DropdownItem disabled>登録なし</DropdownItem>
                                            }
                                        </DropdownMenu>
                                    </Dropdown>
                                </DropdownMenu>
                            </Dropdown>
                        </MenuLi>

                        <MenuLi className="dropdown" >
                            <Dropdown direction="down" isOpen={this.state.dropdownOpenCog} toggle={() => { this.setState({ dropdownOpenCog: !this.state.dropdownOpenCog }); }}>
                                <DropdownToggle
                                    tag="span"
                                    className="fas fa-cog navbar-menu"
                                    data-toggle="dropdown"
                                    aria-expanded={this.state.dropdownOpenCog}
                                >
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem href="https://www.homestation.jp/manage/top/index?settings=1">ガジェットストア</DropdownItem>
                                    <DropdownItem href="https://www.homestation.jp/manage/top/index?settings=2">ガジェット並び替え</DropdownItem>
                                    <DropdownItem href="https://www.homestation.jp/manage/master/holidays">祝日更新</DropdownItem>
                                    <DropdownItem  />
                                    <DropdownItem href="https://www.homestation.jp/manage/login/logout">ログアウト</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </MenuLi>
                    </ul>
                    {/* </nav> */}

                </div >





            </header >
        );
    }
}

export default NavMenu;
